import React from "react";
import Tab from "./Tab";

const App = () => {
  return <Tab />;
};

export default App;
